import { TNullableString, TUnknownObject } from '@common/types/common';
import { lighten, readableColor, transparentize } from 'polished';
import { COLOR_GREEN } from '@common/assets/styles/colors';

export type TWidgetInitData = Record<string, TNullableString>;

export const parseScriptDataAttrs = (htmlElement: HTMLElement): TWidgetInitData => {
  const result: TWidgetInitData = {};

  // Provider ID
  const providerId = htmlElement.getAttribute('data-provider');
  if (!(typeof providerId === 'string' && providerId.length > 0)) {
    throw new Error('Provider not specified');
  }
  result.providerId = providerId;

  // Ambulance ID
  const ambulanceId = htmlElement.getAttribute('data-ambulance');
  result.ambulanceID =
    typeof ambulanceId === 'string' && ambulanceId.length > 0 ? ambulanceId : null;

  // Expertise ID
  const expertiseId = htmlElement.getAttribute('data-expertise');
  result.expertiseId =
    typeof expertiseId === 'string' && expertiseId.length > 0 ? expertiseId : null;

  // Language Sluig
  const langSlug = htmlElement.getAttribute('data-lang');
  result.langSlug = typeof langSlug === 'string' && langSlug.length > 0 ? langSlug : null;

  return result;
};

// TODO, dumb, not finished
export const buildAddressLine = (
  street: TNullableString,
  city: TNullableString,
  postalCode: TNullableString,
  country?: TNullableString,
): string => {
  return `${city} - ${street}${country ? ' ' + country : ''}`;
};

export function getTagColors(slot: TUnknownObject, active: boolean) {
  let backgroundColor = '';
  let textColor = '';

  if (active) {
    backgroundColor = slot.tag ? slot.tag.color : COLOR_GREEN;
    textColor = slot.tag ? readableColor(backgroundColor) : 'white';
  } else {
    backgroundColor = slot.tag
      ? transparentize('0.8', slot.tag.color)
      : lighten('0.25', COLOR_GREEN);
    textColor = slot.tag ? slot.tag.color : COLOR_GREEN;
  }

  return {
    textColor,
    backgroundColor,
  };
}
